import { AppState, UrlPartSerializer } from '@immosky/types';
import { TypedAction } from '@ngrx/store/src/models';
import { setUsageSpaceFilterBasedOnUrlValues } from './usage-space.actions';

export class UsageSpaceFilterSerializer implements UrlPartSerializer {
  constructor(public readonly key: string) {}

  deserialize(urlValue: string): TypedAction<string> {
    const values = urlValue.split(',').map((v) => v.trim());

    const min = parseInt(values[0], 10);
    const max = parseInt(values[1], 10);

    return setUsageSpaceFilterBasedOnUrlValues({
      values: {
        min,
        max,
      },
    });
  }

  serialize(state: AppState): string {
    const usageSpaceFilter = state.filter.usageSpace.filter;
    return `${usageSpaceFilter.min.value},${usageSpaceFilter.max.value}`;
  }
}
